export const site = {
  name: 'LeonDesign',
  category: 'Lederwaren',
  website: 'https://leondesign.nl/',
  email: 'info@leondesign.nl',
  phone: '06-11087851',
  phoneHref: 'tel:+31611087851',
  street: 'Spaans Neerbeek 25',
  postal: '6164 CH',
  city: 'Geleen',
  province: 'Limburg',
  country: 'Nederland',
  kvk: '06091498',
  btw: 'NL001837584B26',
  hours: '24/7',
}

export const socials = [
  { label: 'Facebook', href: 'https://www.facebook.com/LeonDesign.nl/' },
  { label: 'Instagram', href: 'https://www.instagram.com/leondesign.nl/' },
  { label: 'LinkedIn', href: 'https://nl.linkedin.com/company/leondesign' },
  { label: 'X (Twitter)', href: 'https://twitter.com/leondesign' },
]

export const nav = [
  { label: 'Home', to: '/' },
  { label: 'Over ons', to: '/over-ons' },
  { label: 'Collectie', to: '/collectie' },
  { label: 'Bronnen', to: '/bronnen' },
  { label: 'Contact', to: '/contact' },
]

export const images = {
  logo: 'https://cdn.magicpatterns.com/uploads/d7YnGnVeYqwkpGBmwgKnRA/1aalogo.jpg',
  cover: 'https://cdn.magicpatterns.com/uploads/gqTnDsDQJSR1nNfLGYrGAG/2acover.jpg',
  horecaBar:
    'https://cdn.magicpatterns.com/uploads/ezzZJGfgoEKbKFTYWQDF55/652366613_1574922791017774_7700084425291684735_n.jpg',
  horecaTerras:
    'https://cdn.magicpatterns.com/uploads/kXA62ryFSfSVgLgxGtZstA/653701417_1577660777410642_4527767906070061136_n.jpg',
  reviewKarin:
    'https://cdn.magicpatterns.com/uploads/3JMqjoPGgquJpShDNjGAC4/654831862_1580013970508656_5683629481014450649_n.jpg',
  reviewMartin:
    'https://cdn.magicpatterns.com/uploads/8YwYjabqnW7dxmFaRVEK1A/672671522_1604506834726036_1541838988951788600_n.jpg',
}
